module.exports = __webpack_public_path__ + "img/filters_desktop.3b3a9293.svg";